import React from "react";

export const ContratoDetalleSeguimientoContext = React.createContext();